import React from 'react';
import NavigationLarge from '@header/scripts/components/navigation/NavigationLarge.jsx';
import {useBreakpointBetween} from 'bonprix-design-system';
import NavigationSmall from '@header/scripts/components/navigation/NavigationSmall.jsx';
import HamburgerMenu from '@header/scripts/components/HamburgerMenu.jsx';

export default function Navigation({navigation, currentShopId, currentPage, headerRef}) {
    const mobileNavigation = useBreakpointBetween('s', 'xl');

    return (
        <>
            {mobileNavigation && <HamburgerMenu />}
            <nav className="navigation__container-new">
                <NavigationLarge
                    currentPage={currentPage}
                    navigationItems={navigation.navigationItems}
                    texts={navigation.texts}
                />
            </nav>

            {mobileNavigation && (
                <NavigationSmall currentShopId={currentShopId} currentPage={currentPage} headerRef={headerRef} />
            )}
        </>
    );
}
